/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckTokenExpirationResponse
 */
export interface CheckTokenExpirationResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CheckTokenExpirationResponse
     */
    expired: boolean;
}

/**
 * Check if a given object implements the CheckTokenExpirationResponse interface.
 */
export function instanceOfCheckTokenExpirationResponse(value: object): value is CheckTokenExpirationResponse {
    if (!('expired' in value) || value['expired'] === undefined) return false;
    return true;
}

export function CheckTokenExpirationResponseFromJSON(json: any): CheckTokenExpirationResponse {
    return CheckTokenExpirationResponseFromJSONTyped(json, false);
}

export function CheckTokenExpirationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckTokenExpirationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'expired': json['expired'],
    };
}

export function CheckTokenExpirationResponseToJSON(json: any): CheckTokenExpirationResponse {
    return CheckTokenExpirationResponseToJSONTyped(json, false);
}

export function CheckTokenExpirationResponseToJSONTyped(value?: CheckTokenExpirationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'expired': value['expired'],
    };
}

